import Command from "@ckeditor/ckeditor5-core/src/command";
import { CkeditorConstants } from "../../src/utils/ckeditorconstants.js";
import randomUUIDGenerator from '../../src/utils/randomUUIDGenerator.js';
import { checkIfSelectionIsInsertion } from "../../src/utils";

const {
  PLUGINS: { TRACK_CHANGES, TRACKCHANGE_EDITING }, COMMANDS: { CMD_TRACK_CHANGES },
  rightClickOptions: { EDIT_LINK_KEY },
  command: { INSERT_OTHER_DOCUMENT_LINK },
  localStorageItem: { baseHrefForLinkPlugin },
  linksTo, attributeLinkOtherDocument, attributeMediaResource,
  class: { REF },
  htmlElement: { LINK_SPAN, SPAN },
  helperAttributes: { CITATION_COUNT, TYPE_OF },
  htmlAttributes: { ID }
} = CkeditorConstants;

export default class InsertOtherDocumentLinkCommand extends Command {
  execute({ value }) {
    const editor = this.editor;
    let isTextMarkedInGreen = checkIfSelectionIsInsertion(editor);
    isTextMarkedInGreen = isTextMarkedInGreen || !value.textSelected;
    if (value.hasOwnProperty('idLinkAdded')) {
      const range = editor.model.createRangeIn(editor.model.document.getRoot());
      let foundLink = null;

      for (const item of range.getItems({ ignoreElementEnd: true })) {
        if (item.getAttribute(ID) && item.getAttribute(ID) === value['idLinkAdded']) {
          foundLink = item;
        }
      }
      if (foundLink) {
        editor.model.change(writer => {
          writer.setAttribute('resource', value.resource, foundLink);
        });
      }
    } else {
      const id = randomUUIDGenerator();
      editor.model.change(writer => {

        if (
          editor.model?.document?.selection?.getFirstPosition()?.parent &&
          !editor.model.document.selection.getFirstPosition().parent.hasAttribute(CITATION_COUNT) &&
          [TYPE_OF, attributeLinkOtherDocument, attributeMediaResource].includes(editor.model.document.selection.getFirstPosition().parent.getAttribute(TYPE_OF))
        ) {
          writer.remove(editor.model.document.selection.getFirstPosition().parent);
        }
        else {
          const ranges = editor.model.document.selection.getRanges();
          for (const range of ranges) {
            writer.remove(range);
          }
        }
        editor.model.schema.extend(LINK_SPAN, {
          allowAttributes: [
            'id', 'about', 'rel', 'typeof', 'class', 'resource'
          ]
        });
        const baseHref = this.editor.baseHrefForLinkPlugin;
        const attributes = {
          'typeof': value.typeOf,
          'resource': value.resource
        }
        const modelSelection = editor.model.document.selection;
        const selectedElement = modelSelection.getFirstPosition().parent;
        // Check if 'textValue' is true and determine if 'about' attribute should be removed
        const textValue = selectedElement.getAncestors().reverse().find(item => item.hasAttribute('class') && item.getAttribute('class').includes('ckeditor-wrapper'));

        if (localStorage.getItem(EDIT_LINK_KEY) !== 'webemaillink') {
          const linkSpan = writer.createElement(LINK_SPAN)
          writer.insertText(value.linkText, linkSpan);
          writer.setAttributes({
            ...attributes,
            'id': id,
            ...(textValue && { 'about': `${baseHref}#${id}` }),  // Add 'about' if textValue is truthy
            'rel': linksTo,
            'class': REF,
          }, linkSpan);
          const focusPos = editor.model.document.selection?.focus;
          const isInsideLinkSpan = focusPos?.parent?.is?.('element') && (
            focusPos.parent.name === LINK_SPAN ||
            (focusPos.parent.name === SPAN && focusPos.parent.getAttribute?.('rel') === linksTo)
          );
          const safeInsertPos = (isInsideLinkSpan && focusPos?.isAtEnd)
            ? writer.createPositionAfter(focusPos.parent)
            : focusPos;

          if (value.textSelected) {
            writer.insert(linkSpan, safeInsertPos);
            if (editor.commands.get(CMD_TRACK_CHANGES).value && editor.plugins.get(TRACK_CHANGES).isEnabled) {
              const range = writer.createRangeOn(linkSpan);
                editor.plugins.get(TRACKCHANGE_EDITING).markInsertion(range, '', {
                  commandParams: {
                    isTextMarkedInGreen: isTextMarkedInGreen
                  }
                });
            }
          } else {
            writer.insert(linkSpan, safeInsertPos);
            if (editor.commands.get(CMD_TRACK_CHANGES).value && editor.plugins.get(TRACK_CHANGES).isEnabled) {
              const range = writer.createRangeOn(linkSpan);
              editor.plugins.get(TRACKCHANGE_EDITING).markInsertion(range, '', {
                commandParams: {
                  isTextPresent: value.textSelected,
                  isTextMarkedInGreen: isTextMarkedInGreen
                }
              });
            }
          }
        } else {
          const linkSpan = editor.model.document.selection.getFirstPosition().parent;
          writer.setAttributes(attributes, linkSpan);
        }
      })
      localStorage.removeItem(EDIT_LINK_KEY);
      editor.focus();
      editor.fire(INSERT_OTHER_DOCUMENT_LINK, id);
    }
  }
}
